import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import http, { handleHttpError, handleHttpResponse } from '@/services/http'
import { HTTPResponse } from '@/services/http/http.types.ts'
import { IAIAgentMessage } from '@/pages/AIAgent/ai-agent.types.ts'
import httpUtils from '@/services/http/http.utils.ts'

const getDialogMessages = httpUtils.createAbortableRequest(
  (signal, id: IEquipment['id']): Promise<HTTPResponse<IAIAgentMessage[]>> => {
    return http
      .get('/nsi/v1/ai-assistant/chart-history/' + id, { signal })
      .then(handleHttpResponse)
      .catch(handleHttpError)
  }
)

const askQuestion = (
  data: Pick<IAIAgentMessage, 'markdownText' | 'equipmentId'>
): Promise<HTTPResponse<{ questionMessage: IAIAgentMessage; response: IAIAgentMessage }>> => {
  return http.post('/nsi/v1/ai-assistant/ask', data).then(handleHttpResponse).catch(handleHttpError)
}

const aiAgentApi = { getDialogMessages, askQuestion }
export default aiAgentApi
